import { allowedCategoriesData } from '../data/allowedCategories.js'

/**
 * Filter categories based on country and language.
 * To make a specific category visible,
 * please insert the category id within the related brand and country (e.g. bk.de) in allowedCategories.json file.
 * If the brand and country configuration is not present in the file, no filtering is applied.
 * @param  {Array} categories The list of categories returned by API call
 * @param  {String} brand The current brand
 * @param  {String} language The current language
 * @return {Array} Filtered categories
 */
export function filterAllowedCategories (categories, brand, language) {
  if (categories &&
      brand &&
      language &&
      allowedCategoriesData.hasOwnProperty(brand) &&
      allowedCategoriesData[brand].hasOwnProperty(language) &&
      allowedCategoriesData[brand][language]) {
    const allowedCategories = Object.keys(allowedCategoriesData[brand][language]).filter(key => allowedCategoriesData[brand][language][key])
    let filteredCategories = categories.filter(category => {
      return allowedCategories.some(allowedCategory => allowedCategory === category.id)
    })
    return filteredCategories
  }
  return categories
}
